import axios from 'axios'
import { getAPIService } from '../../../getServerHost'
import { NewZone } from '../types'

export const updateGroup = async (payload: { body: NewZone; id: number }) => {
  const { body, id } = payload
  const response = await axios.patch(`${getAPIService}/groups/${id}`, body)
  return response.data
}
